let lottieWeb = null;

const setupLottie = async () => {
    const lotties = document.querySelectorAll(".lottie[data-json-path]");

    if (0 >= lotties.length) {
        return;
    }

    if (!lottieWeb) {
        lottieWeb = await import("lottie-web");
    }

    for (const lottie of lotties) {
        const jsonPath = lottie.getAttribute("data-json-path");
        const animationEl = lottie.querySelector(".lottie__animation");

        if (!jsonPath || !animationEl) {
            continue;
        }

        const placeholder = lottie.querySelector(".lottie__placeholder");
        if (placeholder) {
            placeholder.addEventListener("transitionend", () => {
                placeholder.classList.add("d-none");
                startLottie(animationEl, jsonPath);
            });
            lottie.classList.add("lottie--started");
        } else {
            lottie.classList.add("lottie--started");
            startLottie(animationEl, jsonPath);
        }
    }
};

const startLottie = (animationEl, jsonPath) => {
    lottieWeb.loadAnimation({
        container: animationEl,
        renderer: "svg",
        loop: false,
        autoplay: true,
        path: jsonPath,
    });
};

export {setupLottie};
